import React, {useEffect, useState} from "react";
import {ItemInfo, ItemInfoSpouse} from "../../components/ViewData";
import * as IconMaterial from "@mui/icons-material";
import * as IconFontAwesome from "react-icons/fa6";
import {useTranslation} from "react-i18next";
import {ContactSriInterface} from "../../../services/interface/sri/contact-sri-interface";
import {useTaxPayerStorage} from "../../../services/storage/TaxPayerStorage";
import {useFindContact} from "../../../services/apis/apiRuc";
import NotPermissionComponent from "../../dashboard/NotPermissionComponent";
import NoRecords from "../../components/NoRecords";

interface Props {

}
export default function Contacts({}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const styleIcon = 'max-w-[20px] max-h-[20px]'
    const [contact, setContact] =
        useState<ContactSriInterface | undefined>();

    const person = useTaxPayerStorage(data => data.data)

    const {
        mutate: findContact,
        data: successContact,
        error: errorContact,
        isPending: loadingContact,
    } = useFindContact()

    useEffect(() => {
        if (person?.accountant || person?.taxIdentificationNumber) {
            findContact({
                identifier: person?.accountant ? person?.accountant : person?.taxIdentificationNumber,
                msj: t('contacts')
            })
        }
    }, [person]);

    useEffect(() => {
        if (successContact) {
            // console.log('xxxxxxx contact', contact)
            setContact(successContact)
        }
    }, [successContact]);

    return(
        <div className={'flex flex-col gap-2'}>
            <h3>{t('contacts')}</h3>
            <NotPermissionComponent
                className={'min-h-[50px]'}
                title={'/tax_payer/contact'}
                loading={loadingContact}
                error={errorContact}
                component={ contact ?
                    <>
                        <div className={'mt-1 custom-card py-3 px-3 flex flex-col gap-2 '}>
                            <div className={'grid sm:grid-cols-2 md:grid-cols-2 gap-2'}>
                                {/*<ItemInfo*/}
                                {/*    label={t('website')}*/}
                                {/*    text={contact?.website}*/}
                                {/*    icon={<IconMaterial.LanguageTwoTone className={styleIcon}/>}*/}
                                {/*/>*/}
                                <ItemInfo
                                    label={t('post-office-box')}
                                    text={contact?.postalCode}
                                    icon={<IconMaterial.MarkunreadMailboxTwoTone className={styleIcon}/>}
                                />
                            </div>
                            <div
                                className={'border border-t-1 border-t-secondary border-transparent pt-3 grid sm:grid-cols-2 md:grid-cols-3 gap-2'}>
                                {/*<ItemInfoSpouse label={t('cell-phone')} text={contact?.cellPhone} className={'text-[13px]'}*/}
                                {/*                icon={<IconMaterial.PhoneAndroidTwoTone className={styleIcon}/>}/>*/}
                                {contact?.telephones && contact?.telephones.length > 0 ?
                                    <>{contact?.telephones.map((item, index) => (
                                        <ItemInfoSpouse
                                            key={`phone-${index}`}
                                            label={`${t('phone')} ${index + 1}`}
                                            text={item?.numberPhone}
                                            className={'text-[13px]'}
                                            icon={<IconFontAwesome.FaPhone
                                                className={styleIcon}/>}
                                        />))
                                    }
                                    </> :
                                    <ItemInfoSpouse
                                        label={`${t('phone')}`}
                                        text={t('no-records')}
                                        className={'text-[13px]'}
                                        icon={<IconFontAwesome.FaPhone
                                            className={styleIcon}/>}
                                    />
                                }
                            </div>
                            <div
                                className={'border border-t-1 border-t-secondary border-transparent pt-3 grid sm:grid-cols-2 md:grid-cols-3 gap-2'}>
                                {contact?.emails && contact?.emails.length > 0 ?
                                    <>{contact?.emails.map((item, index) => (
                                        <ItemInfoSpouse
                                            key={`mail-${index}`}
                                            label={`${t('mail')} ${index + 1}`}
                                            text={item?.mail}
                                            className={'text-[13px]'}
                                            icon={<IconMaterial.AlternateEmailTwoTone
                                                className={styleIcon}/>}
                                        />))
                                    }
                                    </> :
                                    <ItemInfoSpouse
                                        label={`${t('mail')}`}
                                        text={t('no-records')}
                                        className={'text-[13px]'}
                                        icon={<IconMaterial.AlternateEmailTwoTone
                                            className={styleIcon}/>}
                                    />
                                }
                            </div>
                        </div>
                    </> : <NoRecords/>
                }
            />
        </div>
    )
}
